export enum ApprovalState {
    // noinspection JSUnusedGlobalSymbols
    ALL,
    APPROVED,
    NOT_APPROVED,
}
